module.exports = __webpack_public_path__ + "static/media/benefits5.b186d0a0.png";